import { InputNumber, Space } from "antd"
import { ViewItem } from "./itemModel"
import Units from "./Units"
import RateCalculator from "./RateCalculator"

type Props = {
  item: Pick<ViewItem, 'quantity' | 'isEntireRowDisabled' | 'units' | 'rateCalculationData'>
  onChange: (value: number) => void
  showRateCalculator?: boolean
}

const ItemQuantity = ({ item, onChange, showRateCalculator = false }: Props) => {
  return <Space>
    <InputNumber
      value={item.quantity}
      disabled={item.isEntireRowDisabled}
      onChange={x => onChange(x ?? 0)}
      addonAfter={<Units width={40} fontSize={11} units={item.units} />}
      style={{ width: 140 }}
      status={item.quantity === 0 ? 'warning' : undefined}
      min={0}
      onFocus={e => e.target.select()}
    />
    {showRateCalculator && <RateCalculator
      disabled={item.isEntireRowDisabled}
      data={item.rateCalculationData}
      onSubmit={onChange}
    />}
  </Space>
}
export default ItemQuantity
